import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { CustomIcon } from 'datastake-daf/dist/components';

const Style = styled.div`
  display: flex;
  gap: var(--size);

  .icon {
    background: #FEF0C7;
    padding: 8px 10px;
    border-radius: 100%; 
    border: 7.47157px solid #FFFAEB;

    svg {
      margin-top: -3px;
      color: #DC6803;
    }
  }

  h3 {
    font-size: var(--font-size-lg);
    font-weight: 700;
    margin-bottom: 8px;
  }

  p {
    color: #667085;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0px;

    span {
      color: var(--color-primary-70);
      cursor: pointer;
    }
  }
`;

export default function NoFocusScp({
  openSettings = () => { },
}) {
  const { t } = useTranslation();

  return (
    <Style>
      <div className="flex-c jus-c">
        <div className="icon">
          <CustomIcon name="Warning" width={19} height={17} />
        </div>
      </div>
      <div className="flex-c jus-c">
        <h3>
          {t('Select a Focus Participant')}
        </h3>
        <p>
          {t('To start populating your Supply Chain Dashboard, please select a focus participant in')}
          {' '}
          <span onClick={openSettings}>
            {t('Data Settings')}
          </span>
        </p>
      </div>
    </Style>
  );
}
